<template>
  <div class="app flex-row align-items-center my-4 mx-5">
    <table class="mainTable h-100 w-100">
      <div style="border: 0px solid">
        <thead style="font-family: iransans">
          <hr />
          <v-row
            id="header"
            class="d-flex justify-content-between align-center"
          >
            <v-col cols="4">
              <b-img src="/img/brand/big.png" class="w-100" />
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="4"
              ><h6 class="font-weight-bold text-center">Packing List</h6></v-col
            >
            <v-divider vertical></v-divider>
            <v-col cols="4" class="d-flex flex-column flex-end">
              <div style="direction: ltr; text-align: left">
                <h6 class="font-weight-bold mt-2 me-2">
                  Number: {{ packingListInfo.packingCode }}
                </h6>
              </div>
              <hr />
              <div style="direction: ltr; text-align: left">
                <h6 class="font-weight-bold mt-1 me-2">
                  Date: {{ packingListInfo.registerDate }}
                </h6>
              </div>
            </v-col>
          </v-row>
          <hr />
          <v-row
            class="py-3 mt-2 d-flex me-2"
            style="direction: ltr; text-align: left"
          >
            <h6 class="font-weight-bold" style="direction: ltr">
              CUSTOMER NAME:
              <span class="me-2">{{ packingListInfo.customerName }}</span>
            </h6>
          </v-row>
          <hr />
          <v-row
            class="py-3 mb-1 d-flex align-center"
            style="direction: ltr; text-align: left"
          >
            <v-col cols="5">
              <h6 class="font-weight-bold me-2" style="direction: ltr">
                ORDER NO: {{ packingListInfo.orderCode }}
              </h6>
            </v-col>
            <v-col cols="7">
              <h6 style="direction: ltr">
                PACKING IN:
                {{ packingListInfo.cartonPack ? "CARTON PACKS" : "" }}
                {{
                  packingListInfo.cartonPack && packingListInfo.woodenPack
                    ? "&"
                    : ""
                }}
                {{ packingListInfo.woodenPack ? "WOODEN PACKS" : "" }}
              </h6>
            </v-col>
          </v-row>
        </thead>
        <tfoot style="font-family: iransans">
          <hr />
          <v-row style="direction: ltr">
            <v-col cols="11" class="text-left">
              <p
                class="d-flex me-2"
                style="direction: ltr !important; font-weight: bold"
              >
                <span>EXPLANATION:</span>
                <span
                  class="me-2"
                  v-html="packingListInfo.packingDescription"
                ></span>
              </p>
            </v-col>
            <!-- <v-col cols="6" class="text-left">
              <p
                style="
                  direction: ltr !important;
                  font-weight: bold;
                  font-size: 12px;
                "
              >
                SUB TOTAL:
                <span class="ms-3">{{ packingListInfo.subTotal.number }}</span
                >,
                <span class="ms-5">{{
                  packingListInfo.subTotal.previousQTY
                }}</span
                >, <span>{{ packingListInfo.subTotal.qty }}</span>
              </p>
            </v-col> -->
            <v-divider vertical></v-divider>
            <v-col cols="1" class="text-left">
              <p
                class="text-center mt-3"
                style="
                  direction: ltr !important;
                  font-weight: bold;
                  font-size: 12px;
                "
              >
                {{ packingListInfo.isComplete ? "K" : "N" }}
              </p>
            </v-col>
          </v-row>
          <hr />
          <v-row style="direction: ltr">
            <v-col cols="6" class="text-left">
              <p
                style="
                  direction: ltr !important;
                  font-weight: bold;
                  font-size: 12px;
                "
                class="me-2"
              >
                PREPARED BY: Mrs M.HADAVAND
              </p>
            </v-col>
            <v-col cols="6">
              <p
                class="d-flex ms-2"
                style="font-weight: bold; font-size: 12px; direction: rtl"
              >
                <span> آدرس محل تحویل:</span>
                <span class="ms-2" v-html="packingListInfo.address"></span>
              </p>
            </v-col>
          </v-row>
          <hr />
          <v-row style="direction: ltr">
            <v-col cols="12" class="text-left">
              <p
                class="me-2"
                style="
                  direction: ltr !important;
                  font-weight: bold;
                  font-size: 12px;
                "
              >
                CONTOLLER BY:J.SHAHBAZIAN
              </p>
            </v-col>
          </v-row>
          <hr />
          <v-row style="direction: ltr">
            <v-col cols="12" class="text-left">
              <p
                class="me-2"
                style="
                  direction: ltr !important;
                  font-weight: bold;
                  font-size: 12px;
                "
              >
                CHECKED BY: E. BANDPEY
              </p>
            </v-col>
          </v-row>
          <hr />
          <v-row style="direction: ltr" class="d-flex align-center">
            <v-col cols="6" class="text-left">
              <p
                class="me-2"
                style="
                  direction: ltr !important;
                  font-weight: bold;
                  font-size: 12px;
                "
              >
                APPROVED BY: A. Hosseini
              </p>
            </v-col>
            <v-col cols="6">
              <p
                class="ms-2 d-flex"
                style="font-weight: bold; font-size: 12px; direction: rtl"
              >
                <span>نام و امضای بازرس:</span>
              </p>
            </v-col>
          </v-row>
          <hr />
          <v-row class="d-flex justify-space-between mb-4">
            <div class="ms-5">
              <span
                >توزيع نسخ: 1-سفيد برنامه ريزی 2-زرد مشتری3-سبزتاييده مشتری
                4-قرمز انبار</span
              >
            </div>
            <div class="me-5"><span>FORM CODE:PKP02F02/01</span></div>
          </v-row>
          <hr />
        </tfoot>
        <tbody>
          <v-row class="mx-3"> </v-row>
          <hr />

          <b-table
            responsive
            show-empty
            :items="packingListInfo.list"
            :fields="originalOrderFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table"
            style="font-family: Tahoma !important"
            small
          >
            <template v-slot:head()="data">
              <div
                dir="ltr"
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                dir="ltr"
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma !important;
                "
              >
                {{ data.index + 1 }}
              </div>
            </template>

            <template #custom-foot="data">
              <b-tr class="text-center">
                <b-td colspan="8"></b-td>
                <b-th>{{ packingListInfo.subTotal ?packingListInfo.subTotal.qty: 0 }}</b-th>
                <b-th>{{ packingListInfo.subTotal ?packingListInfo.subTotal.previousQTY: 0 }}</b-th>
                <b-th>{{ packingListInfo.subTotal ?packingListInfo.subTotal.number: 0 }}</b-th>
                <b-th colspan="2">SUB TOTAL</b-th>
              </b-tr>
            </template>
          </b-table>
        </tbody>
      </div>
    </table>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

export default {
  data() {
    return {
      packingListInfo: {
        list: [],
      },
      originalOrderFields: [
        // { key: "itemCode", label: "شماره سفارش" },
        // { key: "type", label: "نوع کالا" },
        // { key: "priority", label: "اولویت" },
        // { key: "notes", label: "توضیحات تکمیلی" },
        { key: "palletNo", label: "شماره پالت" },
        { key: "boxNo", label: "شماره جعبه" },
        { key: "netWeight", label: "وزن خالص" },
        { key: "grossWeight", label: "وزن غیرخالص" },
        { key: "remarks", label: "نکات تکمیلی" },
        { key: "packingDescription", label: "توضیحات بسته‌بندی" },
        { key: "packingType", label: "نوع بسته‌بندی" },
        { key: "boxCount", label: "تعداد جعبه" },
        { key: "qty", label: "تعداد تحویل" },
        { key: "previousQTY", label: "تعداد قبلی" },
        { key: "number", label: "تعداد کل" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "mapNumber", label: "شماره نقشه" },
        { key: "customerIndex", label: " ردیف مشتری" },
        { key: "index", label: "ردیف" },
      ],
      isBusy: false,
    };
  },
  methods: {
    showPackingList() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/factory/packinglist/getInfo",
        {
          packingListId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.packingListInfo = res.data;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
  },
  computed: {},
  mounted() {
    this.showPackingList();
  },
};
</script>
<style>
p {
  font-family: iransans;
}

td {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}

@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>

<style scoped>
p,
div {
  font-size: 11px;
  line-height: 1rem;
}

thead {
  background-color: white;
  color: black;
}

@media print {
  @page {
    margin: 0;
    size: a4 portrait !important;
    font-size: 30%;
    text-color: black;
    margin: 50px;
  }

  body {
    margin: 1.6cm;
  }

  table {
    border: 1px solid;
  }

  table.mainTable {
    border: 0px !important;
  }

  /* tfoot:after {
      counter-increment: page;
      content: "صفحه " counter(page);
    } */
}
</style>
